import React, { Component } from 'react';
import {
  Container,
  Card,
  CardBody,
  Form,
  FormGroup,
  FormText,
  FormFeedback,
  InputGroup,
  Label,
  Input,
  Button,
} from 'reactstrap';
import Parse from 'parse';

import logo from '../assets/icon.png';

class RegisterCode extends Component {
  constructor(props) {
    super(props);

    this.setAndValidateEmail = this.setAndValidateEmail.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  state = {
    error: undefined,
    user: undefined,
    completed: false,
    email: '',
    code: '',
  };

  setAndValidateEmail(e) {
    const email = e.target.value;
    this.setState({ email });

    const query = new Parse.Query(Parse.User);
    query.equalTo('email', email.toLowerCase());
    query.first().then((user) => {
      this.setState({ user });
    });
  }

  handleSubmit = () => {
    const parameters = {
      book_code: this.state.code,
      user_id: this.state.user.id,
    };

    Parse.Cloud.run('redeemCode', parameters)
      .then(() => {
        this.setState({
          error: undefined,
          user: undefined,
          completed: true,
          email: '',
          code: '',
        });
      })
      .catch((error) => {
        this.setState({ error });
      });
  };

  rednerForm = () => (
    <Form>
      <FormGroup>
        <Label>Email Address</Label>
        <InputGroup size="lg">
          <Input
            valid={this.state.email.length ? this.state.user !== undefined : undefined}
            placeholder="joe@domain.com"
            value={this.state.email}
            onChange={this.setAndValidateEmail}
          />
        </InputGroup>
        <FormText>
          Enter the email address used to create your profile in the BOG REWARDS app: (
          joe@domain.com) . (Hint: it’s the email address that received this note.)
        </FormText>
      </FormGroup>
      <FormGroup>
        <Label>Member ID</Label>
        <Input
          valid={this.state.error ? false : undefined}
          placeholder="Enter the new Member ID"
          bsSize="lg"
          value={this.state.code}
          onChange={e => this.setState({ code: e.target.value })}
        />
        <FormFeedback>
          <strong>{this.state.error ? this.state.error.message : null}</strong>{' '}
          <p>
            Membership validation could not be completed. Please be sure you’ve entered a valid
            Member ID from the newest edition of BestOfGuide.
          </p>
          <p>
            We hope you found the last edition of BOG REWARDS to be of significant value, and
            enjoyed using it for free! The newest edition of BOG REWARDS includes an expanded
            selection of “Best-in-Class” dining, retail, personal and home services, along with
            discounts and promotional offers worth thousands of dollars! For immediate access to
            these valuable offers, go to the BOG REWARDS app and select “My Wallet” for details on
            how to get your subscription started today.
          </p>
        </FormFeedback>
      </FormGroup>
    </Form>
  );

  renderComplete = () => (
    <div>
      <p>
        <strong>
          Congratulations! Your subscription has been renewed. Enjoy using the newest edition of BOG
          REWARDS!
        </strong>
      </p>
      <p>
        TO COMPLETE THE SUBSCRIPTION REACTICVATION PROCESS: close or sign out of the BOG REWARDS app
        completely. Once the app is restarted, the Membership section of My Wallet in the app will
        show a message indicating your code has been activated along with the new expiration date.
      </p>
      <p>
        Thank you for your patronage. Please tell all your friends and family about the value and
        convenience of using the BOG REWARDS app!! And be sure to follow BestOfGuide.com on Facebook
        and Instagram.
      </p>
    </div>
  );

  render() {
    return (
      <Container
        style={{
          paddingTop: 130,
          paddingBottom: 30,
          paddingLeft: 30,
          paddingRight: 30,
        }}
      >
        <Card>
          <div style={{ top: -100 }} className="App-logo">
            <img src={logo} alt="logo" style={{ height: 200, borderRadius: 20 }} />
          </div>
          <CardBody style={{ marginTop: -100 }}>
            <div>
              <h1 className="display-6">BOG Rewards Membership Renewal Validation</h1>
              <p className="lead">
                To validate your Member ID for a free subscription to the 2018 Winter/Spring Edition
                of BOG REWARDS.
              </p>
            </div>
          </CardBody>
          <div style={{ backgroundColor: '#f6f6f6' }}>
            <CardBody>{this.state.completed ? this.renderComplete() : this.rednerForm()}</CardBody>
          </div>
          <CardBody>
            <Button
              className="App-button"
              size="lg"
              onClick={this.handleSubmit}
              disabled={this.state.user ? this.state.code.length !== 10 : true}
              hidden={this.state.completed}
            >
              Submit
            </Button>
          </CardBody>
        </Card>
      </Container>
    );
  }
}

export { RegisterCode };



// WEBPACK FOOTER //
// ./src/code/register-code.js